/* eslint-disable max-len */
import React from 'react';
function Calendar() {
    return (React.createElement("g", null,
        React.createElement("path", { d: "M19,3h-1V1h-2v2H8V1H6v2H5C3.9,3,3,3.9,3,5v14c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V5C21,3.9,20.1,3,19,3z M19,19H5V9h14V19z" })));
}
export default Calendar;
